import moment from 'moment';

export const environment = {
    production: false,
    development: true,
    local: false,

    API_SERVER_URL: 'https://api-bienes-culturales.mypeopleapps.com',
    API_VENTANILLA_AGIL: 'https://ventanilla-agil-drbc.mypeopleapps.com',
    URL_BASE_PARA_IMAGENES:'https://va.mcd.gob.gt/Resources/upd/',

    TODAYS_DATE: `${moment().format('YYYY-MM-DD').toString()} 00:00`,
    TIPOLOGIA_CLASIFICACION_FORMULARIOS: 160840,
    TIPOLOGIA_ID_SOLICITUDES: 160752,
    TIPOLOGIA_ID_GESTIONES:160796,
    TIPOLOGIA_ID_BIENES_CULTURALES:160797,
    TIPOLOGIA_PADRE_ID_PRIORIDAD: 160785,
    TIPOLOGIA_PADRE_ID_ESTADO_SOLICITUD: 160792,
    TIPOLOGIA_ID_ESTADO_ADMITIDA: 160795,
    TIPOLOGIA_PADRE_ID_ESTADO_GESTIONES: 160745,
    TIPOLOGIA_PADRE_ID_SECCION: 160734,
    TIPOLOGIA_PADRE_ID_ROLES: 160730,
    TIPOLOGIA_ID_ESTADO_RECHAZADA:160850,
    TIPOLOGIA_PADRE_ID_ORIGEN_TAREA: 160819,
    ESTADO_ID_USUARIO_ACTIVO:160445,
    ESTADO_ID_USUARIO_INACTIVO:160446,
    ESTADO_ID_USUARIO_PENDIENTE:160447,
    TIPOLOGIA_ID_SECCION_PREHISPANICA: 160735,
    TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA:160736,
    TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES:160737,
    TIPOLOGIA_ID_ESTADO_SOLICITUD_CORRECCION: 161022,
    TIPOLOGIA_ID_BIEN_INMUEBLE:161062,
    TIPOLOGIA_ID_BIEN_MUEBLE:161063,
    TIPOLOGIA_ID_SERVICIO:160801,
    TIPOLOGIA_ID_VALOR:160810,
    TIPOLOGIA_ID_TIPO_REPRESENTACION:161064,
    TIPOLOGIA_ID_TITULAR:160852,
    TIPOLOGIA_ID_DEPARTAMENTOS:160060,
    TIPOLOGIA_ID_COLECCIONES:161025,
    TIPOLOGIA_ID_TIPO_PROPIEDAD:160798

}